import React from 'react';

/**
 * Spinner component.
 */
const Spinner = () => (
  <div className="spinner-border text-primary" role="status">
    <span className="sr-only">Loading...</span>
  </div>
);

export default Spinner;
